import { render, staticRenderFns } from "./Comissao.vue?vue&type=template&id=84122ce8"
import script from "./Comissao.vue?vue&type=script&lang=js"
export * from "./Comissao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports